var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserSolid(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0647 10.7198C7.87303 10.7198 6.09052 8.94365 6.09052 6.7598C6.09052 4.57595 7.87303 2.7998 10.0647 2.7998C12.2564 2.7998 14.0389 4.57595 14.0389 6.7598C14.0389 8.94365 12.2564 10.7198 10.0647 10.7198ZM15.8454 17.1996H4.28407C3.68658 17.1996 3.2002 16.715 3.2002 16.1196C3.2002 16.0706 3.21013 14.9064 4.08536 13.7436C4.59478 13.0668 5.29207 12.5291 6.15826 12.1461C7.21594 11.6772 8.53058 11.4396 10.0647 11.4396C11.5988 11.4396 12.913 11.6772 13.9712 12.1461C14.8374 12.53 15.5346 13.0668 16.0441 13.7436C16.9193 14.9064 16.9292 16.0706 16.9292 16.1196C16.9292 16.715 16.4428 17.1996 15.8454 17.1996Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSolid);
export default __webpack_public_path__ + "static/media/user-solid.829c04f472e7b75355ec21925854faa0.svg";
export { ForwardRef as ReactComponent };